













import Vue from 'vue';
import HMChat from '@/web/components/chat/HMChat.vue';
import { pick } from 'lodash';

export default Vue.extend({
  components: {
    HMChat,
  },
  data() {
    return {
      stream_chat_token: null,
      chat_channel_id: null,
      event_name: null,
      user_id: null,
      user_name: null,
    };
  },
  mounted() {
    Object.assign(
      this,
      pick(this.$route.query, [
        'stream_chat_token',
        'chat_channel_id',
        'event_name',
        'user_id',
        'user_name',
      ])
    );
  },
});
